module.exports = __webpack_public_path__ + "img/spaceGameGif2.eaf972ff.gif";